import React from 'react'
import './url404.scss'
import HeaderSec from '../../Components/HeaderSec/HeaderSec'
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import mainimg from '../../Assets/img/Frame 1000005413@2x.png'
import { data } from './errorPageData'
import FooterComp from '../../Components/FooterComp/FooterComp';
import './url404.scss'


const Url404 = () => {
    const [TempSearch, setTempSearch] = useState()
    const [showInfoBox, setShowInfoBox] = useState(false)
    const navigate = useNavigate();

    const onChange = (e) => {
        const { value } = e?.target;
        setTempSearch(value);
    }
    const CallSearch = () => {
        const query = encodeURIComponent(TempSearch.trim());
        navigate(`/search?landing=${query}`, { replace: true }); // Update URL without refreshing
    };
    const searchParams = new URLSearchParams(window.location.search);
    const landing = searchParams.get('landing');

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            CallSearch();
        }
    }
    useEffect(() => {
        setTempSearch(landing || ''); // Set the state to the query or an empty string
    }, [landing]);
    const handleAnchor = () => {
        setShowInfoBox(true);
        // Hide the box after 5 seconds
        setTimeout(() => {
            setShowInfoBox(false);
        }, 5000);
    }
    return (
        <>
            <HeaderSec />
            <div className='ErrorPage'>
                <div className='landing'>
                    <div className="inner">
                        <div className="left">
                            <h1 className='text-[20px]'>
                                <span className='text-red-800 text-[40px]' >SORRY!</span>
                                <br />
                                {data.mainHeadding}
                            </h1>
                            <h2>{data.subHeadding}</h2>
                            <div className="inputlayout">
                                <div className="input">
                                    <input onKeyDown={handleKeyDown} value={TempSearch} onChange={onChange} type="text" placeholder={data.inputPlaceHolder} />

                                </div>
                                <div className='flex gap-[10px] max-sm:mt-[10px]'>
                                    <button className='px-[10px] h-[40px] rounded-md max-md:rounded-l-md rounded-l-none font-bold text-[white] bg-[#004878]' onClick={CallSearch} >SEARCH</button>
                                    <Link to='/loginDataUser'>
                                        <button className='register px-[10px] h-[40px] rounded-md font-bold text-[white]'>REGISTER FOR FREE</button>
                                    </Link>
                                </div>

                                <div className="underlinePtag">
                                    <h4 className=''>GuideStar Number (GSN) of our NPO/ NGO Partners has not changed.</h4>
                                    <p href="" onClick={handleAnchor}>Why register for more free searches</p>
                                </div>

                            </div>


                            {showInfoBox && (
                                <div className="info-box">
                                    If you register to create your GuideStar account, you get free access to more information, including: <br />
                                    view more than 5 NPO profiles, view audited accounts (where available), view NPO email ids, etc. You can also post offers and campaigns, choose to be notified on areas of your interest. <br />
                                </div>
                            )}
                            <h2>Explore our <a className=' underline' href="/search">Advanced Search!</a>  You may also visit our <a className='underline' href="/"> home page</a>, use the links in the main menu and in the
                                footer. If you still cannot find what you were looking for, just <a className=' underline' href="/contact">Contact Us</a> or write to info at guidestarindia dot
                                org</h2>
                        </div>

                        <div className="right max-lg:flex max-lg:justify-center">
                            <img className='w-[100%] rounded-bl-[40px]' src={mainimg} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <FooterComp />


        </>
    )
}

export default Url404